import React from "react"

const Prev = ({ fill }) => (
	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.8333 7.49984H1.16663M1.16663 7.49984L6.99996 13.3332M1.16663 7.49984L6.99996 1.6665"
			stroke={fill || "#fff"}
			strokeWidth="1.67"
			strokeLinecap="round"
			strokeLinejoin="round"/>
	</svg>
)

export default Prev